import { c as _c } from "react/compiler-runtime";
import { ReactElement, ReactNode, createContext, useContext } from 'react';
const FlagsContext = createContext<{
  [key: string]: boolean;
} | undefined>(undefined);
interface FlagsProviderProps {
  flags?: {
    [key: string]: boolean;
  };
  children: ReactNode;
}
export const FlagsProvider = t0 => {
  const $ = _c(7);
  const {
    flags: t1,
    children
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const flags = t2;
  let t3;
  if ($[2] !== flags) {
    t3 = {
      ...flags
    };
    $[2] = flags;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <FlagsContext.Provider value={t3}>{children}</FlagsContext.Provider>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export function useFlags() {
  const $ = _c(2);
  const context = useContext(FlagsContext);
  let t0;
  if ($[0] !== context) {
    t0 = context ?? {};
    $[0] = context;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}